import { useSelector, useDispatch } from 'react-redux'
import { useState } from 'react'
import { bindActionCreators } from 'redux'
import { actionCreators } from '../state/actionCreatorCompiler'

const Content = () => {
 
  const [loader, setLoader] = useState(false)

  const operation = useSelector(state => state.operation)
  const result = useSelector(state => state.result)
  const equation = useSelector(state => state.equation)
  const dispatch = useDispatch()

  const { changeOperation, updateInput, setResult } = bindActionCreators(actionCreators, dispatch)

  const newtonRequest = async () => {
    setResult('')
    setLoader(true)
  
    if(equation === '') {
      setResult('Please enter equation')
      setLoader(false)
      return
    }

    try {
      const response = await fetch(`https://newton.now.sh/api/v2/${operation}/${equation}`)
      const data = await response.json()
      setLoader(false)
      setResult(data.result)
    } catch(e) {
      setResult('Failed to Compute')
      setLoader(false)
    }
  }

  const handleInputChange = e => updateInput(e.target.value),
        handleChange = e => changeOperation(e.target.value)

  return (
    <>
      <div className="einstein-result">
        <ul className={`einstein-result__loader ${loader && 'einstein-result__loader--active'}`}>
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <p className="einstein-text einstein-text--result"> &nbsp; {result} </p>
      </div>
      <div className="einstein-flex-container">
        <div className="einstein-select-container">
          <select className="einstein-select" onChange={e => handleChange(e)}>
            <option value="simplify"> Simplify </option>
            <option value="factor"> Factor </option>
            <option value="derive"> Derive </option>
            <option value="integrate"> Integrate </option>
            <option value="zeroes"> Find 0's </option>
            <option value="tangent"> Find Tangent </option>
            <option value="area"> Area Under Curve </option>
            <option value="cos"> Cosine </option>
            <option value="sin"> Sine </option>
            <option value="tan"> Tangent </option>
            <option value="arccos"> Inverse Cosine </option>
            <option value="arcsin"> Inverse Sine </option>
            <option value="arctan"> Inverse Tangent </option>
            <option value="abs"> Absolute Value </option>
            <option value="log"> Logarithm </option>
          </select>
        </div>
        <input className="einstein-input" type="text" placeholder="place your equation here" onChange={e => handleInputChange(e)} />
      </div>
      <button className="einstein-button" onClick={newtonRequest}> Compute </button>
    </>
  )
}

export default Content